import React from 'react';

function OrderCard({ order }) {
  const num = order?.order_number;
  const hasOrderNumber = num && num.trim() !== '';
  const isOrderStatus = order?.intent === 'order_status';

  const shipToValue = order?.ship_to && typeof order.ship_to === 'object' ? order.ship_to.name : order?.ship_to;
  const soldToValue = order?.sold_to_number || order?.sold_to?.number || order?.sold_to;

  // Build fields list based on intent, only include fields with actual data
  let fields = [];
  if (isOrderStatus) {
    if (order?.order_status) fields.push({ label: 'Order Status', value: order.order_status });
    if (order?.estimated_delivery_date) fields.push({ label: 'Estimated Delivery Date', value: order.estimated_delivery_date });
    if (soldToValue) fields.push({ label: 'Sold\u2011to Number', value: soldToValue });
  } else {
    if (order?.order_status) fields.push({ label: 'Current Status', value: order.order_status });
    if (shipToValue) fields.push({ label: 'Ship\u2011to', value: shipToValue });
    if (order?.order_date) fields.push({ label: 'Order Date', value: order.order_date });
    if (order?.order_total) fields.push({ label: 'Order Total', value: order.order_total });
    if (order?.estimated_delivery_date) fields.push({ label: 'Estimated Delivery Date', value: order.estimated_delivery_date });
    if (soldToValue) fields.push({ label: 'Sold\u2011to Number', value: soldToValue });
  }

  return (
    <div className="order-card">
      <div className="order-card-header">
        <span className="order-card-title">
          {hasOrderNumber ? `Order Number ${num}` : 'Order Number Not Found!'}
        </span>
        <button className="order-mgmt-btn" onClick={() => window.open('https://buildings.honeywell.com/us/en/home', '_blank')}>
          Open in Order Management ↗
        </button>
      </div>
      {hasOrderNumber && fields.length > 0 && (
        <div className="order-detail-grid">
          {fields.map((f) => (
            <div className="order-field" key={f.label}>
              <span className="order-field-label">{f.label}</span>
              <span className="order-field-value">{f.value}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default OrderCard;
